// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file modules/apiengine/services/login/login.proto (package aurora.core.apiengine.loginv1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file modules/apiengine/services/login/login.proto.
 */
export const file_modules_apiengine_services_login_login: GenFile = /*@__PURE__*/
  fileDesc("Cixtb2R1bGVzL2FwaWVuZ2luZS9zZXJ2aWNlcy9sb2dpbi9sb2dpbi5wcm90bxIdYXVyb3JhLmNvcmUuYXBpZW5naW5lLmxvZ2ludjEiQwoeTG9naW5XaXRoQXBpQ3JlZGVudGlhbHNSZXF1ZXN0EhEKCWNsaWVudF9pZBgBIAEoCRIOCgZzZWNyZXQYAiABKAkiNwofTG9naW5XaXRoQXBpQ3JlZGVudGlhbHNSZXNwb25zZRIUCgxhY2Nlc3NfdG9rZW4YASABKAkiZgofTG9naW5XaXRoVXNlckNyZWRlbnRpYWxzUmVxdWVzdBINCgVlbWFpbBgBIAEoCRIQCghwYXNzd29yZBgCIAEoCRIVCghvdHBfY29kZRgDIAEoCUgAiAEBQgsKCV9vdHBfY29kZSJPCiBMb2dpbldpdGhVc2VyQ3JlZGVudGlhbHNSZXNwb25zZRIUCgxhY2Nlc3NfdG9rZW4YASABKAkSFQoNcmVmcmVzaF90b2tlbhgCIAEoCSIkChNSZWZyZXNoVG9rZW5SZXF1ZXN0Eg0KBXRva2VuGAEgASgJIkMKFFJlZnJlc2hUb2tlblJlc3BvbnNlEhQKDGFjY2Vzc190b2tlbhgBIAEoCRIVCg1yZWZyZXNoX3Rva2VuGAIgASgJIigKFkNvbmZpcm1JZGVudGl0eVJlcXVlc3QSDgoGc2VjcmV0GAEgASgJIhkKF0NvbmZpcm1JZGVudGl0eVJlc3BvbnNlIiwKGkxvZ2luV2l0aFNBTUxUaWNrZXRSZXF1ZXN0Eg4KBnRpY2tldBgBIAEoCSJKChtMb2dpbldpdGhTQU1MVGlja2V0UmVzcG9uc2USFAoMYWNjZXNzX3Rva2VuGAEgASgJEhUKDXJlZnJlc2hfdG9rZW4YAiABKAky3AUKDExvZ2luU2VydmljZRKaAQoXTG9naW5XaXRoQXBpQ3JlZGVudGlhbHMSPS5hdXJvcmEuY29yZS5hcGllbmdpbmUubG9naW52MS5Mb2dpbldpdGhBcGlDcmVkZW50aWFsc1JlcXVlc3QaPi5hdXJvcmEuY29yZS5hcGllbmdpbmUubG9naW52MS5Mb2dpbldpdGhBcGlDcmVkZW50aWFsc1Jlc3BvbnNlIgASnQEKGExvZ2luV2l0aFVzZXJDcmVkZW50aWFscxI+LmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5sb2dpbnYxLkxvZ2luV2l0aFVzZXJDcmVkZW50aWFsc1JlcXVlc3QaPy5hdXJvcmEuY29yZS5hcGllbmdpbmUubG9naW52MS5Mb2dpbldpdGhVc2VyQ3JlZGVudGlhbHNSZXNwb25zZSIAEnkKDFJlZnJlc2hUb2tlbhIyLmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5sb2dpbnYxLlJlZnJlc2hUb2tlblJlcXVlc3QaMy5hdXJvcmEuY29yZS5hcGllbmdpbmUubG9naW52MS5SZWZyZXNoVG9rZW5SZXNwb25zZSIAEoIBCg9Db25maXJtSWRlbnRpdHkSNS5hdXJvcmEuY29yZS5hcGllbmdpbmUubG9naW52MS5Db25maXJtSWRlbnRpdHlSZXF1ZXN0GjYuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmxvZ2ludjEuQ29uZmlybUlkZW50aXR5UmVzcG9uc2UiABKOAQoTTG9naW5XaXRoU0FNTFRpY2tldBI5LmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5sb2dpbnYxLkxvZ2luV2l0aFNBTUxUaWNrZXRSZXF1ZXN0GjouYXVyb3JhLmNvcmUuYXBpZW5naW5lLmxvZ2ludjEuTG9naW5XaXRoU0FNTFRpY2tldFJlc3BvbnNlIgBCQFo+Z2l0bGFiLnBydmJsLmNvbS9hdXJvcmEvY29yZS9zcmMvbW9kdWxlcy9hcGllbmdpbmUvYXBpL2xvZ2ludjFiBnByb3RvMw");

/**
 * @generated from message aurora.core.apiengine.loginv1.LoginWithApiCredentialsRequest
 */
export type LoginWithApiCredentialsRequest = Message<"aurora.core.apiengine.loginv1.LoginWithApiCredentialsRequest"> & {
  /**
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * @generated from field: string secret = 2;
   */
  secret: string;
};

/**
 * Describes the message aurora.core.apiengine.loginv1.LoginWithApiCredentialsRequest.
 * Use `create(LoginWithApiCredentialsRequestSchema)` to create a new message.
 */
export const LoginWithApiCredentialsRequestSchema: GenMessage<LoginWithApiCredentialsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_login, 0);

/**
 * @generated from message aurora.core.apiengine.loginv1.LoginWithApiCredentialsResponse
 */
export type LoginWithApiCredentialsResponse = Message<"aurora.core.apiengine.loginv1.LoginWithApiCredentialsResponse"> & {
  /**
   * access token with a TTL of 1 week
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message aurora.core.apiengine.loginv1.LoginWithApiCredentialsResponse.
 * Use `create(LoginWithApiCredentialsResponseSchema)` to create a new message.
 */
export const LoginWithApiCredentialsResponseSchema: GenMessage<LoginWithApiCredentialsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_login, 1);

/**
 * @generated from message aurora.core.apiengine.loginv1.LoginWithUserCredentialsRequest
 */
export type LoginWithUserCredentialsRequest = Message<"aurora.core.apiengine.loginv1.LoginWithUserCredentialsRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: optional string otp_code = 3;
   */
  otpCode?: string;
};

/**
 * Describes the message aurora.core.apiengine.loginv1.LoginWithUserCredentialsRequest.
 * Use `create(LoginWithUserCredentialsRequestSchema)` to create a new message.
 */
export const LoginWithUserCredentialsRequestSchema: GenMessage<LoginWithUserCredentialsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_login, 2);

/**
 * @generated from message aurora.core.apiengine.loginv1.LoginWithUserCredentialsResponse
 */
export type LoginWithUserCredentialsResponse = Message<"aurora.core.apiengine.loginv1.LoginWithUserCredentialsResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message aurora.core.apiengine.loginv1.LoginWithUserCredentialsResponse.
 * Use `create(LoginWithUserCredentialsResponseSchema)` to create a new message.
 */
export const LoginWithUserCredentialsResponseSchema: GenMessage<LoginWithUserCredentialsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_login, 3);

/**
 * @generated from message aurora.core.apiengine.loginv1.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"aurora.core.apiengine.loginv1.RefreshTokenRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message aurora.core.apiengine.loginv1.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_login, 4);

/**
 * @generated from message aurora.core.apiengine.loginv1.RefreshTokenResponse
 */
export type RefreshTokenResponse = Message<"aurora.core.apiengine.loginv1.RefreshTokenResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message aurora.core.apiengine.loginv1.RefreshTokenResponse.
 * Use `create(RefreshTokenResponseSchema)` to create a new message.
 */
export const RefreshTokenResponseSchema: GenMessage<RefreshTokenResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_login, 5);

/**
 * @generated from message aurora.core.apiengine.loginv1.ConfirmIdentityRequest
 */
export type ConfirmIdentityRequest = Message<"aurora.core.apiengine.loginv1.ConfirmIdentityRequest"> & {
  /**
   * @generated from field: string secret = 1;
   */
  secret: string;
};

/**
 * Describes the message aurora.core.apiengine.loginv1.ConfirmIdentityRequest.
 * Use `create(ConfirmIdentityRequestSchema)` to create a new message.
 */
export const ConfirmIdentityRequestSchema: GenMessage<ConfirmIdentityRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_login, 6);

/**
 * @generated from message aurora.core.apiengine.loginv1.ConfirmIdentityResponse
 */
export type ConfirmIdentityResponse = Message<"aurora.core.apiengine.loginv1.ConfirmIdentityResponse"> & {
};

/**
 * Describes the message aurora.core.apiengine.loginv1.ConfirmIdentityResponse.
 * Use `create(ConfirmIdentityResponseSchema)` to create a new message.
 */
export const ConfirmIdentityResponseSchema: GenMessage<ConfirmIdentityResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_login, 7);

/**
 * @generated from message aurora.core.apiengine.loginv1.LoginWithSAMLTicketRequest
 */
export type LoginWithSAMLTicketRequest = Message<"aurora.core.apiengine.loginv1.LoginWithSAMLTicketRequest"> & {
  /**
   * @generated from field: string ticket = 1;
   */
  ticket: string;
};

/**
 * Describes the message aurora.core.apiengine.loginv1.LoginWithSAMLTicketRequest.
 * Use `create(LoginWithSAMLTicketRequestSchema)` to create a new message.
 */
export const LoginWithSAMLTicketRequestSchema: GenMessage<LoginWithSAMLTicketRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_login, 8);

/**
 * @generated from message aurora.core.apiengine.loginv1.LoginWithSAMLTicketResponse
 */
export type LoginWithSAMLTicketResponse = Message<"aurora.core.apiengine.loginv1.LoginWithSAMLTicketResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;
};

/**
 * Describes the message aurora.core.apiengine.loginv1.LoginWithSAMLTicketResponse.
 * Use `create(LoginWithSAMLTicketResponseSchema)` to create a new message.
 */
export const LoginWithSAMLTicketResponseSchema: GenMessage<LoginWithSAMLTicketResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_login_login, 9);

/**
 * All methods of the Aurora Connect-API require an `access token`.
 * You can call `LoginWithApiCredentials` to get your `access token`.
 *
 * The TTL of an access token is 1 week.
 * Please make sure your application will request a new token every week.
 *
 * @generated from service aurora.core.apiengine.loginv1.LoginService
 */
export const LoginService: GenService<{
  /**
   * Request an access token.
   * To identify, please request a `client_id` and `secret` from your representative at Provable Markets.
   *
   * Please note the services expect a JWT ***Bearer*** Token.
   * For instance, when you pass the `access_token` to a `cURL` request you will have to pass it in the header like this:
   *
   * ```shell
   *    curl -H "Authorization: Bearer YOUR_ACCESS_TOKEN"
   * ```
   * Unfortunately the keyword `Bearer` is currently missing from the examples.
   *
   * @generated from rpc aurora.core.apiengine.loginv1.LoginService.LoginWithApiCredentials
   */
  loginWithApiCredentials: {
    methodKind: "unary";
    input: typeof LoginWithApiCredentialsRequestSchema;
    output: typeof LoginWithApiCredentialsResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.loginv1.LoginService.LoginWithUserCredentials
   */
  loginWithUserCredentials: {
    methodKind: "unary";
    input: typeof LoginWithUserCredentialsRequestSchema;
    output: typeof LoginWithUserCredentialsResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.loginv1.LoginService.RefreshToken
   */
  refreshToken: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof RefreshTokenResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.loginv1.LoginService.ConfirmIdentity
   */
  confirmIdentity: {
    methodKind: "unary";
    input: typeof ConfirmIdentityRequestSchema;
    output: typeof ConfirmIdentityResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.loginv1.LoginService.LoginWithSAMLTicket
   */
  loginWithSAMLTicket: {
    methodKind: "unary";
    input: typeof LoginWithSAMLTicketRequestSchema;
    output: typeof LoginWithSAMLTicketResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_modules_apiengine_services_login_login, 0);

